import { useTranslations } from 'next-intl';
import React from 'react';

import { IconLocation24 } from '@cineamo/ui/src/icons/ic-location';

const NoShowingsFound: React.FC = () => {
    const t = useTranslations();
    return (
        <div className="my-32 flex flex-col space-y-8 items-center text-center">
            <IconLocation24 />
            <div>
                <div className="text-body-bold-16">{t('showtimes-finder.search.no-showings-found.title')}</div>
                <div className="text-body-12 opacity-70">
                    {t('showtimes-finder.search.no-showings-found.description')}
                </div>
            </div>
        </div>
    );
};

export default NoShowingsFound;
